import "./qualification.css";

function Qualification() {
  return (
    <section className="qualification section" id="portfolio">
      <h2 className="section_title">Qualification</h2>
      <span className="section_subtitle">My Personel journey</span>

      <div className="qualification_container container">
        <div className="qualification_tabs">
          <div className="qualification_button button_flex qualification_content_active">
            <i className="uil uil-graduation-cap qualification_active qualification_icon"></i>
            Education
          </div>
        </div>

        <div className="qualification_sections">
          <div className="qualification_content qualification_content_active">
            <div className="qualification_data">
              <div></div>
              <div>
                <span className="qualification_rounder"></span>
                <span className="qualification_line"></span>
              </div>
              <div>
                <h3 className="qualification_title">Next Js</h3>
                <div className="qualification_calendar">
                  <i className="uil uil-calendar-alt"></i>
                  2023 - Present
                </div>
              </div>
            </div>

            <div className="qualification_data">
              <div>
                <h3 className="qualification_title">React Js</h3>
                <div className="qualification_calendar">
                  <i className="uil uil-calendar-alt"></i>
                  2023
                </div>
              </div>

              <div>
                <span className="qualification_rounder"></span>
                <span className="qualification_line"></span>
              </div>
            </div>

            <div className="qualification_data">
              <div></div>
              <div>
                <span className="qualification_rounder"></span>
                <span className="qualification_line"></span>
              </div>
              <div>
                <h3 className="qualification_title">Typescript</h3>
                <div className="qualification_calendar">
                  <i className="uil uil-calendar-alt"></i>
                  2022 - 2023
                </div>
              </div>
            </div>

            <div className="qualification_data">
              <div>
                <h3 className="qualification_title">Alpine Js</h3>
                <div className="qualification_calendar">
                  <i className="uil uil-calendar-alt"></i>
                  2022 - 2023
                </div>
              </div>

              <div>
                <span className="qualification_rounder"></span>
                <span className="qualification_line"></span>
              </div>
            </div>

            <div className="qualification_data">
              <div></div>
              <div>
                <span className="qualification_rounder"></span>
                <span className="qualification_line"></span>
              </div>
              <div>
                <h3 className="qualification_title">Tailwindcss</h3>
                <div className="qualification_calendar">
                  <i className="uil uil-calendar-alt"></i>
                  2021 - 2022
                </div>
              </div>
            </div>

            <div className="qualification_data">
              <div>
                <h3 className="qualification_title">Sass</h3>
                <div className="qualification_calendar">
                  <i className="uil uil-calendar-alt"></i>
                  2021 - 2022
                </div>
              </div>

              <div>
                <span className="qualification_rounder"></span>
                <span className="qualification_line"></span>
              </div>
            </div>

            <div className="qualification_data">
              <div></div>
              <div>
                <span className="qualification_rounder"></span>
                <span className="qualification_line"></span>
              </div>
              <div>
                <h3 className="qualification_title">jQuery</h3>
                <div className="qualification_calendar">
                  <i className="uil uil-calendar-alt"></i>
                  2021 - 2022
                </div>
              </div>
            </div>

            <div className="qualification_data">
              <div>
                <h3 className="qualification_title">BootStrap</h3>
                <div className="qualification_calendar">
                  <i className="uil uil-calendar-alt"></i>
                  2021
                </div>
              </div>

              <div>
                <span className="qualification_rounder"></span>
                <span className="qualification_line"></span>
              </div>
            </div>

            <div className="qualification_data">
              <div></div>
              <div>
                <span className="qualification_rounder"></span>
                <span className="qualification_line"></span>
              </div>
              <div>
                <h3 className="qualification_title">Javascript</h3>
                <div className="qualification_calendar">
                  <i className="uil uil-calendar-alt"></i>
                  2021
                </div>
              </div>
            </div>

            <div className="qualification_data">
              <div>
                <h3 className="qualification_title">HTML & CSS</h3>
                <div className="qualification_calendar">
                  <i className="uil uil-calendar-alt"></i>
                  2021
                </div>
              </div>

              <div>
                <span className="qualification_rounder"></span>
                <span className="qualification_line"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Qualification;
